module.exports = function replaceCharAt(str, index, replacement) {
    str = str.split('');
    str[index] = replacement;
    return str.join('');
};



// WEBPACK FOOTER //
// ./src/TimeInput/lib/replace-char-at.js